"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ViewportSizeType = exports.ColumnSizeType = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var ColumnSizeType = exports.ColumnSizeType = _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].bool]);
var ViewportSizeType = exports.ViewportSizeType = _propTypes["default"].oneOf(['xs', 'sm', 'md', 'lg']);